import axios, { AxiosResponse } from "axios";
import { axiosInstance } from "core/api/httpInterceptors";

/**
 * Common method through which all API requests are passed
 * @param endPoint
 * @param method
 * @param data
 * @returns
 */
export function httpRequest(
  endPoint: any,
  method: string,
  data?: any,
  base: { status: boolean; url: string } = { status: true, url: "" },
  config?: any,
): Promise<AxiosResponse<any>> {
  const isMock = endPoint && endPoint.isMock ? endPoint.isMock : false;
  const requestMethod = isMock ? "get" : method;
  // choose between mock or api url
  const baseUrl = isMock
    ? import.meta.env.VITE_MOCK_API_URL
    : import.meta.env.VITE_API_URL;

  const requestUrl =
    base.status === false && base.url
      ? base.url
      : endPoint && endPoint.url
        ? baseUrl + endPoint.url
        : baseUrl;

  switch (requestMethod) {
    case "get":
      return get(requestUrl);
    case "post":
      return post(requestUrl, data);
    case "postFile":
      return postFile(requestUrl, data, config);
    case "put":
      return put(requestUrl, data, config);
    case "postUrlencoded":
      return postUrlencoded(requestUrl, data);
    case "delete":
      return deleteItem(requestUrl);
    default:
      throw new Error(`Unsupported method: ${method}`);
  }
}

function get(url: string) {
  return axiosInstance.get(url);
}

function post(url: string, data: any) {
  return axiosInstance.post(url, data);
}

function postFile(url: string, data: any, config: any) {
  return axiosInstance.post(url, data, config);
}

function postUrlencoded(url: string, data: any) {
  const dataObj = Object.keys(data)
    .map((key) => `${key}=${encodeURIComponent(data[key])}`)
    .join("&");
  return axiosInstance.post(url, dataObj);
}

function put(url: string, data: any, config: any) {
  return axiosInstance.put(url, data, config);
}

function deleteItem(url: string) {
  return axiosInstance.delete(url);
}
